<h2>Site Users</h2>

<mat-spinner *ngIf="initializing"></mat-spinner>

<div class="button_row" *ngIf="!initializing">
    <button mat-raised-button
            routerLink="/">Back</button>

    <button mat-raised-button
            color="primary"
            matTooltip="Export {{dataSource?.filteredData?.length || 0}} users"
            (click)="export()">Export</button>

    <button mat-raised-button
            color="primary"
            [disabled]="selectedCount==0"
            matTooltip="Export {{selectedCount}} selected users"
            (click)="exportSelected()">Export Selected</button>
</div>

<div id="table_area">
    <div *ngIf="visibleUsers?.length && !initializing" class="paginator_row">
        <span>
            <mat-form-field>
                <mat-label>Filter</mat-label>
                <input matInput
                       [(ngModel)]="filter"
                       (keyup)="applyFilter($event)"
                       (keydown.escape)="clearFilter()">
            </mat-form-field>
            <button mat-icon-button
                    [ngClass]="{hidden: !filter}"
                    color="accent"
                    matTooltip="Clear filter"
                    (click)="clearFilter()">
                <mat-icon>highlight_off</mat-icon>
            </button>
        </span>
        <mat-checkbox [(ngModel)]="showDisabled"
                      (ngModelChange)="disabledChanged()">Show disabled users</mat-checkbox>
        <mat-paginator #paginator
                       [hidden]="initializing"
                       [length]="visibleUsers?.length"
                       [pageIndex]="INITIAL_PAGE_INDEX"
                       [pageSize]="INITIAL_PAGE_SIZE"
                       [pageSizeOptions]="[5, 10, 20]"
                       (page)="pageChanged($event)"></mat-paginator>
    </div>
    <table mat-table *ngIf="visibleUsers?.length && !initializing"
           [dataSource]="dataSource">

        <ng-container matColumnDef="selected">
            <th mat-header-cell *matHeaderCellDef rowspan="2">
                <button mat-icon-button
                        matTooltip="Clear selection"
                        class="clear_selection"
                        *ngIf="selectedCount>0"
                        (click)="clearSelection()">
                    <mat-icon>highlight_off</mat-icon>
                </button>
            </th>
            <td mat-cell *matCellDef="let user" class="check">
                <mat-checkbox [(ngModel)]="user.selected"
                              (ngModelChange)="updateSelection()"></mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef rowspan="2">Email</th>
            <td mat-cell *matCellDef="let user" [innerHTML]="user.email" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef rowspan="2">First Name</th>
            <td mat-cell *matCellDef="let user" [innerHTML]="user.firstName" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef rowspan="2">Last Name</th>
            <td mat-cell *matCellDef="let user" [innerHTML]="user.lastName" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="birthDate">
            <th mat-header-cell *matHeaderCellDef rowspan="2">Birth Date</th>
            <td mat-cell class="date" *matCellDef="let user" [innerHTML]="user.birthDate | date" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef rowspan="2">Added</th>
            <td mat-cell class="date" *matCellDef="let user" [innerHTML]="user.created | date" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="orderCount">
            <th mat-header-cell *matHeaderCellDef rowspan="2" class="order_count">Order Count</th>
            <td mat-cell class="order_count" *matCellDef="let user" [innerHTML]="user.orderCount" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="latestOrder">
            <th mat-header-cell *matHeaderCellDef colspan="6">Latest Order</th>
        </ng-container>

        <ng-container matColumnDef="orderNumber">
            <th mat-header-cell *matHeaderCellDef>Order #</th>
            <td mat-cell class="order_number" *matCellDef="let user" [innerHTML]="user.orderNumber" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="orderStatus">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell class="status" *matCellDef="let user" [innerHTML]="user.orderStatus" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="orderTotal">
            <th mat-header-cell class="total" *matHeaderCellDef>Total</th>
            <td mat-cell class="total right" *matCellDef="let user" [innerHTML]="user.orderTotal | currency" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="orderTime">
            <th mat-header-cell *matHeaderCellDef>Placed</th>
            <td mat-cell class="date" *matCellDef="let user" [innerHTML]="user.orderTime | date" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>Shipping Address</th>
            <td mat-cell *matCellDef="let user" [innerHTML]="getShippingAddress(user)" (click)="showUser(user)"></td>
        </ng-container>

        <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Phone</th>
            <td mat-cell class="phone" *matCellDef="let user" [innerHTML]="user.phone | phone" (click)="showUser(user)"></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['selected', 'email', 'firstName', 'lastName', 'birthDate', 'created', 'orderCount', 'latestOrder']"></tr>
        <tr mat-header-row *matHeaderRowDef="['orderNumber', 'orderStatus', 'orderTotal', 'orderTime', 'address', 'phone']"></tr>
        <tr mat-row [ngClass]="{disabled: user.disabled}"
            *matRowDef="let user; columns: columnsToDisplay"></tr>

    </table>
</div>